import { render, staticRenderFns } from "./AlbumStatisticsCard.vue?vue&type=template&id=3404990b&scoped=true"
import script from "./AlbumStatisticsCard.vue?vue&type=script&lang=js"
export * from "./AlbumStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./AlbumStatisticsCard.vue?vue&type=style&index=0&id=3404990b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404990b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3404990b')) {
      api.createRecord('3404990b', component.options)
    } else {
      api.reload('3404990b', component.options)
    }
    module.hot.accept("./AlbumStatisticsCard.vue?vue&type=template&id=3404990b&scoped=true", function () {
      api.rerender('3404990b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/AlbumStatisticsCard.vue"
export default component.exports